/**
 * 保养提醒设置
 */
import { MAINTAINSETTING } from '../types';

export default {
    name: `${MAINTAINSETTING}`,
    path: '/maintainSetting',
    component: () => import(/* webpackChunkName: 'maintainSetting' */ '@/views/maintainSetting/'),
    redirect: { name: `${MAINTAINSETTING}Index` },
    meta: {
        title: '保养提醒设置',
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${MAINTAINSETTING}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'maintainSetting' */ '@/views/maintainSetting/home/Home.vue'),
        },

        // 二级页面示例, 详情
        {
            name: `${MAINTAINSETTING}Detail`,
            path: 'detail/:ruleId',
            component: () => import(/* webpackChunkName: 'maintainSetting' */ '@/views/maintainSetting/detail/Detail.vue'),
        },
    ],
};
